enum WarehouseType {
    GeneralRoom = 1,
    ValveRoom = 2
}

export default WarehouseType